import React, { Component } from "react";
import { ProjectService } from "../Services/ProjectService";
import { StoreTransactionService } from "../Services/StoreTransactionService";
import { ItemService } from "../Services/ItemService";
import { UserService } from "../Services/UserService";
import {toInt, getTimeInIST, format, format_display} from '../Utils';
import Paper from '@material-ui/core/Paper';
import SelectDropdown from '../components/SelectDropdown';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { RowCountOptions } from "../Config";
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CallMadeIcon from '@material-ui/icons/CallMade';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// import ListItemText from '@material-ui/core/ListItemText';
// import IconButton from '@material-ui/core/IconButton';
// import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';

const styles = theme =>({
    fab: {
        margin: theme.spacing.unit,
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      paddingTop : theme.spacing.unit, 
      paddingLeft: theme.spacing.unit, 
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    tablecell: {
        fontSize: '40pt',
        padding: '5px'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    table: {
        minWidth: 700
    },
    list: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "30%",
        },
        right: "22px"
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    formControl: {
        margin: theme.spacing.unit,
        marginTop: theme.spacing.unit * 3,
        minWidth: 200,
        marginLeft: theme.spacing.unit * 2,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing.unit * 4,
        },
    }
  });

class StoreTransaction extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        filter: '',
        new_transaction: {id: undefined, project_id: "", item_id: "", txn_type: "", user_id: "", qty: "", comments: ""},
        show: false,
        columns : [
            { id: 'project_name', numeric: false, disablePadding: true, label: 'Project', sortable: true },
            { id: 'txn_type', numeric: false, disablePadding: true, label: 'Txn Type', sortable: true },
            { id: 'item_name', numeric: false, disablePadding: true, label: 'Item', sortable: true  },
            { id: 'qty', numeric: false, disablePadding: true, label: 'Quantity', sortable: true  },
            { id: 'comments', numeric: false, disablePadding: true, label: 'Comments', sortable: true  },
            { id: 'contractor_name', numeric: false, disablePadding: true, label: 'Contractor' , sortable: true },
            { id: 'txn_date', numeric: false, disablePadding: true, label: 'Transaction Date' , sortable: true },
            { id: 'created_by', numeric: false, disablePadding: true, label: 'Created By', sortable: true  },
        ],
        order: 'asc',
        orderBy: 'name',
        message : '',
        master_items: [],
        master_contractors: [],
        master_txn_types: [{id: 'INWARD',name: 'INWARD'},{id: 'OUTWARD', name: 'OUTWARD'}],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        project_names: [],
        project_names_master: [],
        selected_project: "-1",
        selected_item_id: "-1",
        selected_txn_type: "-1",
        items_row: [],
        txn_type_row: [],
        error_fields: {project_id : false, user_id: false, job_action_id: false, qty: false, comments: false, txn_type: false}
      }

      this.handleSelect = this.handleSelect.bind(this);

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.newTransaction = this.newTransaction.bind(this);
      this.createModifyTransaction = this.createModifyTransaction.bind(this);

      //Sort
      this.sortBy = this.sortBy.bind(this);
    }

    componentWillMount(){
        this.props.setTitle('Store Transactions');
        this.props.isLoading(true);
        this.fetchContractors();
        // this.fetchItems();
        this.fetchProjectFilter();
        this.fetchItemFilter();
        this.fetchTxnTypeFilter();
    }

    fetchProjectFilter = () => {
        ProjectService.getProjectNames()
        .then((data) => {
            let project_names = data.projects.map((project) => (
                <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
            ));   
            project_names.unshift(<MenuItem key={"-1"} value={"-1"}>All Projects</MenuItem>);
            this.setState({project_names_master: data.projects, project_names: project_names});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchItemFilter = () => {
        ItemService.getItemList()
        .then((data) => {
            let items_rows = data.items.map((item) => (
                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            ));   
            items_rows.unshift(<MenuItem key={"-1"} value={"-1"}>All Items</MenuItem>);
            this.setState({items_row: items_rows});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchTxnTypeFilter = () => {
        let txn_type_rows = this.state.master_txn_types.map((txn_type) => (
            <MenuItem key={txn_type.id} value={txn_type.id}>{txn_type.name}</MenuItem>
        ));   
        txn_type_rows.unshift(<MenuItem key={"-1"} value={"-1"}>All Transaction Types</MenuItem>);
        this.setState({txn_type_rows: txn_type_rows});
    }

    fetchItems(project_id){
        ItemService.getItemList(project_id)
        .then((data) => {
            this.setState({master_items: data.items});
        })
        .catch((error) =>{
            console.log("Error while fetching Items list");
        });
    }

    fetchContractors(){
        UserService.getContractorList()
        .then((data) => {
            this.setState({master_contractors: data.users});
        })
        .catch((error) =>{
            console.log("Error while fetching Contractors list");
        });
    }
 
    componentDidMount(){
        this.fetchData(0, this.state.numItemsPerPage);
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems){
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let project_id = this.state.selected_project === "-1" ? null : this.state.selected_project;
        let item_id = this.state.selected_item_id === "-1" ? null : this.state.selected_item_id;
        let txn_type = this.state.selected_txn_type === "-1" ? null : this.state.selected_txn_type;

        StoreTransactionService.getTotalCount(project_id, item_id, txn_type, null, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format))
        .then((data) => {
            this.setState({
                totalItems: toInt(data.count), 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            StoreTransactionService.getStoreTransactions(start, numberItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), project_id, txn_type, item_id, null, sort, direction)
            .then((data) => {
                this.setState({data: data.transactions, originalData: data.transactions});
                if(data.transactions){
                    data.transactions.forEach((txn) => {
                        rows.push(<TransactionDetails key={txn.id} txn={txn}/>);
                    });
                    this.setState({
                        current_rows: rows
                    });
                }
                
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleChange = (e) => {
        let change = this.state.new_transaction;
        let project_id = change.project_id;
        if(e.target.name === 'txn_type' && e.target.value === 'INWARD'){
            project_id = this.state.project_names_master.filter(p => p.status === '-999')[0].id;
            change.user_id = this.props.user.id;
            this.fetchItems(null);
        } else if(e.target.name === 'txn_type' && e.target.value === 'OUTWARD'){
            change.user_id = "";
            project_id = this.state.project_names_master.filter(p => p.status !== '-999').length === 1 ? this.state.project_names_master.filter(p => p.status !== '-999')[0].id : "";
            if(this.state.project_names_master.filter(p => p.status !== '-999').length === 1){
                this.fetchItems(project_id);
            }
        }
        if(e.target.name === 'project_id'){
            this.fetchItems(e.target.value);
        }
        e.preventDefault();
        change[e.target.name] = e.target.value;

        if(e.target.name === 'txn_type'){
            change.project_id = project_id;
        }

        let error_fields = this.state.error_fields;
        error_fields[e.target.name] = false;
        
        this.setState({
            new_transaction: change,
            error_fields: error_fields
        });
    }

    newTransaction(e, project){
        if(project) {
            // let rows = this.updateProjectItemRows(project.items);
            this.setState({new_transaction: {id: project.id, name: project.name, description: project.description, qty: project.qty, status: project.status, created_date: project.created_date, created_by: project.created_by, modified_date: project.modified_date, items:  project.items.slice(), job_actions: project.job_actions.slice()}});
        }
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_transaction: {id: undefined, project_id: "", item_id: "", txn_type: "", user_id: "", qty: "", comments: ""},
            error_fields: {project_id : false, user_id: false, item_id: false, txn_type: false, qty: false, comments: false},
            master_items: []
        });
    }
    
    handleShow() {
        this.setState({ show: true });
    }

    confirmSave = () => {
        let new_transaction = this.state.new_transaction;
        this.props.isLoading(true);
        new_transaction.comments = new_transaction.comments && new_transaction.comments.length ?  new_transaction.comments: null;
        new_transaction.txn_date = moment.utc().format(format);
        let headers = {user_id : this.props.user.id };
        StoreTransactionService.createTransaction(headers, {transactions: [new_transaction]})
        .then((response) => {
            this.props.closeConfirmDialog();
            this.props.isLoading(false);
            console.log(response);
            if(response.exceeding_stock > 0){
                this.props.showConfirmDialog("Requested item exceeds the available stock, currently available stock is " + response.transactions[0].available_stock, "error", undefined);
            } else if(response.exceeding_allocated_qty > 0){
                this.props.showConfirmDialog(`Requested item exceeds the project required quantity, Quantity consumed is: ${response.transactions[0].qty_consumed_already}, Remaining that can be consumed is ${(response.transactions[0].remaining_allocation <= 0) ? 0 : response.transactions[0].remaining_allocation}. Please provide proper comments if more is needed.`, "Warning", undefined);
            } else {
                this.handleClose();
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            }
        })
        .catch(error => {
            this.props.showSnackBar(`Something went wrong. Please try again later.` , 'error');
            this.props.isLoading(false);
        });
    }

    createModifyTransaction(e){
        e.preventDefault();
        let new_transaction = this.state.new_transaction;
        let error_fields = this.state.error_fields;
        if(new_transaction.project_id && new_transaction.item_id && new_transaction.txn_type && new_transaction.user_id && toInt(new_transaction.qty) > 0){
            this.setState({new_transaction : new_transaction}, () => this.props.showConfirmDialog("Create transaction", "Confirm", this.confirmSave));
            return;
        }
        if(!new_transaction.project_id) {
            error_fields.project_id = true;
        }
        if((toInt(new_transaction.qty)|| 0) <= 0) {
            error_fields.qty = true;
        } 
        if(!new_transaction.item_id){
            error_fields.item_id = true;
        }
        if(!new_transaction.txn_type){
            error_fields.txn_type = true;
        } 
        if(!new_transaction.user_id){
            error_fields.user_id = true;
        }
        this.setState({error_fields: error_fields});
    }
    
    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleProjectSelection = (e) => {
        this.setState({selected_project: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleItemSelection = (e) => {
        this.setState({selected_item_id: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleTxnTypeSelection = (e) => {
        this.setState({selected_txn_type: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }
    
    render() {
        let message = this.state.message;
        const { classes } = this.props;
        return (
            <div className="Home">
                <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                    <InputLabel
                        ref={ref => {
                        this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-project-simple"
                    >
                        Project
                    </InputLabel>
                    <Select
                        value={this.state.selected_project}
                        onChange={this.handleProjectSelection}
                        input={
                        <OutlinedInput
                            labelWidth={50}
                            name="Project"
                            id="outlined-project-simple"
                        />
                        }
                    >
                        {this.state.project_names}
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                    <InputLabel
                        ref={ref => {
                        this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-item-simple"
                    >
                        Item
                    </InputLabel>
                    <Select
                        value={this.state.selected_item_id}
                        onChange={this.handleItemSelection}
                        input={
                        <OutlinedInput
                            labelWidth={50}
                            name="Item"
                            id="outlined-item-simple"
                        />
                        }
                    >
                        {this.state.items_row}
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                        this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-txn_type-simple"
                    >
                        Txn Type
                    </InputLabel>
                    <Select
                        value={this.state.selected_txn_type}
                        onChange={this.handleTxnTypeSelection}
                        input={
                        <OutlinedInput
                            labelWidth={50}
                            name="Project"
                            id="outlined-txn_type-simple"
                        />
                        }
                    >
                        {this.state.txn_type_rows}
                    </Select>
                </FormControl>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                        margin="normal"
                        label="From"
                        value={this.state.startDate}
                        onChange={this.handleChangeStartDate}
                        format='DD MMM YYYY'
                        maxDate={this.state.endDate}
                        variant="outlined"
                        className={classes.formControl}
                        style={{float: "left", height: "100%", marginTop: "24px"}}
                    />
                    <DatePicker
                        margin="normal"
                        label="To"
                        value={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                        maxDate={moment()}
                        format='DD MMM YYYY'
                        className={classes.formControl}
                        variant="outlined"
                        style={{float: "left", height: "100%", marginTop: "24px"}}
                    />
                </MuiPickersUtilsProvider>
                <div className="container">
                    <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    { !message &&
                        <Paper className={this.props.classes.root} style={{width: "100%", marginTop: "50px", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Table className={classes.table}>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows ={this.state.columns} />
                                    { !this.props.loading && 
                                        <TableBody>
                                            {this.state.current_rows}
                                        </TableBody>
                                    }
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">Create Transaction</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <SelectDropdown required error={this.state.error_fields.txn_type} disabled={this.state.master_txn_types.length === 0} label="Txn type" hint="Select Transaction type" name="txn_type" options={this.state.master_txn_types} value={this.state.new_transaction.txn_type} onChange={this.handleChange} />
                                <SelectDropdown required error={this.state.error_fields.project_id} disabled={this.state.new_transaction.txn_type === 'INWARD' || this.state.new_transaction.txn_type === ""} label="Project" hint="Select Project" name="project_id" options={this.state.new_transaction.txn_type === 'OUTWARD' ? this.state.project_names_master.filter(p => p.status !== '-999') : this.state.project_names_master} value={this.state.new_transaction.project_id} onChange={this.handleChange} />
                                <SelectDropdown required error={this.state.error_fields.item_id} disabled={this.state.master_items.length === 0} label="Item" hint="Select Item" name="item_id" options={this.state.master_items} value={this.state.new_transaction.item_id} onChange={this.handleChange} />
                                {(this.state.new_transaction.txn_type || 'OUTWARD') === 'OUTWARD' && <SelectDropdown required error={this.state.error_fields.user_id} disabled={this.state.new_transaction.txn_type === 'INWARD' || this.state.master_contractors.length === 0} label="Contractor" hint="Select Contractor" name="user_id" options={this.state.master_contractors} value={this.state.new_transaction.user_id} onChange={this.handleChange} /> }
                                <TextField
                                    id="qty"
                                    label="Quantity"
                                    placeholder="Quantity"
                                    name="qty"
                                    defaultValue={this.state.new_transaction.qty}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    error={this.state.error_fields.qty}
                                    helperText="Enter Quantity"
                                    type="number"
                                    InputProps={{
                                        inputProps: { min: 1, max: this.state.master_items.filter(i => i.id === this.state.new_transaction.item_id)[0] && this.state.master_items.filter(i => i.id === this.state.new_transaction.item_id)[0].project_item_qty }
                                    }}
                                    style={{marginTop: '8px'}}
                                    />
                                <TextField
                                    id="comment"
                                    label="Comments"
                                    placeholder="Comments"
                                    name="comments"
                                    fullWidth
                                    error={this.state.error_fields.comments}
                                    defaultValue={this.state.new_transaction.comment}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    multiline
                                    rows="2"
                                    type="text"
                                    />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Close
                            </Button>
                            <Button onClick={this.createModifyTransaction} color="primary" autoFocus>
                                Save
                            </Button>
                        </DialogActions>
                </DialogMUI>
                { this.state.project_names_master.length > 0 && 
                    <Fab onClick={this.newTransaction} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                        <AddIcon />
                    </Fab>
                }
            </div>
        );
    }

}

class TransactionDetails extends Component {

    render(){
      const txn = this.props.txn;

        return (
            <TableRow key={txn.id}>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{txn.project_name}</Typography>
                </TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2"> {txn.txn_type === 'INWARD' ? <CallReceivedIcon color="primary" style={{verticalAlign: "bottom"}}/>  : <CallMadeIcon color="secondary" style={{verticalAlign: "bottom"}}/> }{txn.txn_type}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.item_name}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.qty}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="body1" color="textSecondary">{txn.comments}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.txn_type === 'OUTWARD' ? txn.contractor_name : "NA"}</Typography></TableCell>
                <TableCell align="center"  padding='none'>{getTimeInIST(txn.txn_date).format(format_display)}</TableCell>
                <TableCell align="center"  padding='none'>{txn.created_by}</TableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(StoreTransaction);